import { Component, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'fe-card-flight-information',
    templateUrl: './card-flight-information.component.html',
    styleUrls: ['./card-flight-information.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class CardFlightInformationComponent {
    public formFlightInformation!: FormGroup;

    constructor(private readonly formBuilder: FormBuilder) {
        this.initFormFlightInformation();
    }

    private initFormFlightInformation(): void {
        this.formFlightInformation = this.formBuilder.group({
            airlineName: ['', Validators.compose([])],
            flightNumber: ['', Validators.compose([])],
            airlineNameReturn: ['', Validators.compose([])],
            flightNumberReturn: ['', Validators.compose([])],
        });
    }

    public getForm(): FormGroup {
        return this.formFlightInformation;
    }
}
